// Position configuration (shared between languages)
const positionConfig = {
    image: {
        top: '120px',
        left: '200px',
        width: '400px'
    }
};

export const scoring_level_eng = {
    // Display configuration for English version
    displayConfig: {
        pageToShow: 13,
        position: {
            ...positionConfig,
            description: {
                top: '340px',
                left: '13%',
                transform: 'translateX(-50%)',
                fontSize: '17px',
                fontWeight: 700,
                width: '600px',
                textAlign: 'center',
                display: 'block',
                fontFamily: '"Gilroy-Regular", sans-serif'
            },
            description_2: {
                top: '365px',
                left: '12%',
                transform: 'translateX(-50%)',
                fontSize: '17px',
                fontWeight: 700,
                width: '600px',
                textAlign: 'center',
                display: 'block',
                fontFamily: '"Gilroy-Regular", sans-serif'
            }
        }
    },
    
    // Scoring levels
    levels: [
        {
            min: 0,
            max: 3,
            img: 'level_1',
            color: '#8bcc2c',
            description: 'Your test results show a <span style="color: #8bcc2c; font-weight: bold;">Considerably Balanced</span> in your gut bacteria,',
            description_2: 'which could increase the risk of some diseases.',
            fontFamily: '"Gilroy-Regular", sans-serif',
            fontFamily_2: '"Gilroy-Regular", sans-serif'
        },
        {
            min: 4,
            max: 6,
            img: 'level_2',
            color: '#fa891f',
            description: 'Your test results show a <span style="color: #ccc72c; font-weight: bold;">Mild Dysbiosis</span> in your gut bacteria,',
            description_2: 'which could increase the risk of some diseases.',
            fontFamily: '"Gilroy-Regular", sans-serif',
            fontFamily_2: '"Gilroy-Regular", sans-serif'
        },
        {
            min: 7,
            max: 12,
            img: 'level_3',
            color: '#f97316',
            description: 'Your test results show a <span style="color: #cc832c; font-weight: bold;">Moderate Dysbiosis</span> in your gut bacteria,',
            description_2: 'which could increase the risk of some diseases.',
            fontFamily: '"Gilroy-Regular", sans-serif',
            fontFamily_2: '"Gilroy-Regular", sans-serif'
        },
        {
            min: 13,
            max: 100,
            img: 'level_4',
            color: '#fa1f1f',
            description: ['Your test results show a <span style="color: #cc2c2c; font-weight: bold;">Significant Dysbiosis</span> in your gut bacteria,'],
            description_2: 'which could increase the risk of some diseases.',
            fontFamily: '"Gilroy-Regular", sans-serif',
            fontFamily_2: '"Gilroy-Regular", sans-serif'
        }
    ]
};

export const scoring_level_thai = {
    // Display configuration for Thai version
    displayConfig: {
        pageToShow: 12,
        position: {
            ...positionConfig,
            description: {
                top: '340px',
                left: '8%',
                transform: 'translateX(-50%)',
                fontSize: '17px',
                fontWeight: 700,
                width: '600px',
                textAlign: 'center',
                display: 'block',
                fontFamily: '"Noto Sans Thai", sans-serif'
            },
            description_2: {
                top: '365px',
                left: '12%',
                transform: 'translateX(-50%)',
                fontSize: '17px',
                fontWeight: 700,
                width: '600px',
                textAlign: 'center',
                display: 'block',
                fontFamily: '"Noto Sans Thai", sans-serif'
            }
        }
    },
    
    // Scoring levels
    levels: [
        {
            min: 0,
            max: 3,
            img: 'level_1',
            color: '#8bcc2c',
            description: 'จากผลตรวจวิเคราะห์ข้างต้น ระดับความสมดุลของจุลินทรีย์ในลำไส้ของคุณ คือ <span style="color: #8bcc2c; font-weight: bold;">สมดุลดีมาก</span>',
            description_2: 'ซึ่งอาจเพิ่มความเสี่ยงของอาการ',
            fontFamily: '"Noto Sans Thai", sans-serif',
            fontFamily_2: '"Noto Sans Thai", sans-serif'
        },
        {
            min: 4,
            max: 6,
            img: 'level_2',
            color: '#fa891f',
            description: 'จากผลตรวจวิเคราะห์ข้างต้น ระดับความสมดุลของจุลินทรีย์ในลำไส้ของคุณ คือ <span style="color: #ccc72c; font-weight: bold;">เสียสมดุลเล็กน้อย</span>',
            description_2: 'ซึ่งอาจเพิ่มความเสี่ยงของอาการ',
            fontFamily: '"Noto Sans Thai", sans-serif',
            fontFamily_2: '"Noto Sans Thai", sans-serif'
        },
        {
            min: 7,
            max: 12,
            img: 'level_3',
            color: '#f97316',
            description: 'จากผลตรวจวิเคราะห์ข้างต้น ระดับความสมดุลของจุลินทรีย์ในลำไส้ของคุณ คือ <span style="color: #cc832c; font-weight: bold;">เสียสมดุลปานกลาง</span>',
            description_2: 'ซึ่งอาจเพิ่มความเสี่ยงของอาการ',
            fontFamily: '"Noto Sans Thai", sans-serif',
            fontFamily_2: '"Noto Sans Thai", sans-serif'
        },
        {
            min: 13,
            max: 100,
            img: 'level_4',
            color: '#fa1f1f',
            description: ['จากผลตรวจวิเคราะห์ข้างต้น ระดับความสมดุลของจุลินทรีย์ในลำไส้ของคุณ คือ <span style="color: #cc2c2c; font-weight: bold;">เสียสมดุลรุนแรง</span>'],
            description_2: 'ซึ่งอาจเพิ่มความเสี่ยงของอาการ',
            fontFamily: '"Noto Sans Thai", sans-serif',
            fontFamily_2: '"Noto Sans Thai", sans-serif'
        }
    ]
};

// Helper function to evaluate bacteria condition with proper number handling
const evaluateCondition = (condition, ctValue, formData, bacteriaName) => {
    if (typeof condition !== 'function') {
        return false;
    }
    
    // Convert ctValue to number (handles string values from CSV)
    const numericValue = parseFloat(ctValue);
    if (isNaN(numericValue)) {
        return false;
    }
    
    // Create a copy of formData with numeric Universal bacteria value
    const normalizedFormData = { ...formData };
    if (formData['Universal bacteria']) {
        normalizedFormData['Universal bacteria'] = parseFloat(formData['Universal bacteria']) || 0;
    }
    
    return condition(numericValue, normalizedFormData);
};

// Function to calculate the overall score based on CT value results
export const calculateOverallScore = (formData, bacteriaMetaConfig) => {
    let score = 0;
    
    // Count each type of result
    let slightlyExcessiveCount = 0;
    let slightlyDeficientCount = 0;
    let excessiveCount = 0;
    let deficientCount = 0;
    
    // Debug logging
    console.log('🔍 calculateOverallScore (QPT) - Starting calculation');
    console.log('🔍 FormData Universal bacteria:', formData['Universal bacteria'], 'type:', typeof formData['Universal bacteria']);
    
    // Iterate through all bacteria in the config
    Object.keys(bacteriaMetaConfig).forEach(bacteriaName => {
        const bacteriaConfig = bacteriaMetaConfig[bacteriaName];
        const ctValue = formData[bacteriaName];
        
        if (ctValue !== undefined && ctValue !== null && ctValue !== '') {
            // Convert to number for comparison
            const numericCtValue = parseFloat(ctValue);
            
            if (!isNaN(numericCtValue)) {
                // Find the matching range for this bacteria using helper function
                const matchingRange = bacteriaConfig.rangeMapping.find(range => 
                    evaluateCondition(range.condition, ctValue, formData, bacteriaName)
                );
                
                if (matchingRange) {
                    const label = matchingRange.label;
                    
                    // Count based on the label
                    switch (label) {
                        case 'Slightly Excessive':
                            slightlyExcessiveCount++;
                            break;
                        case 'Slightly Deficient':
                            slightlyDeficientCount++;
                            break;
                        case 'Excessive':
                            excessiveCount++;
                            break;
                        case 'Deficient':
                            deficientCount++;
                            break;
                        default:
                            // Normal or other labels don't contribute to the score
                            break;
                    }
                }
            }
        }
    });
    
    // Apply the formula
    score = 0.5 * slightlyExcessiveCount + 0.5 * slightlyDeficientCount + excessiveCount + deficientCount;
    
    console.log('🔍 Overall Dysbiosis Calculation:');
    console.log(`  Slightly Excessive: ${slightlyExcessiveCount}`);
    console.log(`  Slightly Deficient: ${slightlyDeficientCount}`);
    console.log(`  Excessive: ${excessiveCount}`);
    console.log(`  Deficient: ${deficientCount}`);
    console.log(`  Raw Score: ${score}`);
    console.log(`  Rounded Score: ${Math.round(score)}`);
    
    return Math.round(score); // Round to nearest integer
};

// Function to get the appropriate scoring level based on the calculated score
export const getScoringLevel = (score, useThaiVersion = false) => {
    const config = useThaiVersion ? scoring_level_thai : scoring_level_eng;
    
    return config.levels.find(level => score >= level.min && score <= level.max) || config.levels[config.levels.length - 1];
};

// Function to check if scoring level should be shown on a specific page
export const shouldShowScoringLevel = (pageNumber, totalPages, useThaiVersion = false) => {
    const config = useThaiVersion ? scoring_level_thai : scoring_level_eng;
    const { pageToShow } = config.displayConfig;
    
    if (typeof pageToShow === 'number') {
        return pageNumber === pageToShow;
    }
    
    if (pageToShow === 'first') {
        return pageNumber === 1;
    }
    
    if (pageToShow === 'last') {
        return pageNumber === totalPages;
    }
    
    if (pageToShow === 'all') {
        return true;
    }
    
    if (Array.isArray(pageToShow)) {
        return pageToShow.includes(pageNumber);
    }
    
    // Default to page 1 if invalid configuration
    return pageNumber === 1;
};

// Function to get display configuration for a specific language
export const getScoringDisplayConfig = (useThaiVersion = false) => {
    const config = useThaiVersion ? scoring_level_thai : scoring_level_eng;
    return config.displayConfig;
};